import { generateUniqueId } from 'utils/global';
import * as actionType from './actionTypes';

export function setApplicationStatus(status:string) {
  return {
    type: actionType.SET_APPLICATION_STATUS,
    payload: status,
  }
}

export function setAppState(appState:string) {
  return {
    type: actionType.SET_APP_STATE,
    payload: appState,
  }
}

export function setDefaultPrinter(printerName:string) {
  return {
    type: actionType.SET_DEFAULT_PRINTER,
    payload: printerName,
  }
}

export function setSupplierId(organisation:[]) {
  return {
    type: actionType.SET_SUPPLIERID,
    payload: organisation,
  }
}

export function addNotification(notification:{}) {
  return {
    type: actionType.ADD_NOTIFICATION,
    payload: { ...notification, id: generateUniqueId() },
  }
}

export function removeNotification(id:string) {
  return {
    type: actionType.REMOVE_NOTIFICATION,
    payload: id,
  }
}